import apiService from "../../api/api.service";
import {
  CargoTrackingMetadataResponse,
  CargoTrackingResultResponse,
  TrackOrderRequest,
} from "./shippingTracking.types";

export const fetchCargoTrackingMetadata =
  async (): Promise<CargoTrackingMetadataResponse> => {
    return apiService.get<CargoTrackingMetadataResponse>(
      "/general/cargo-tracking-metadata",
    );
  };

export const fetchTrackOrder = async ({
  orderNumber,
  phone_number,
}: TrackOrderRequest): Promise<CargoTrackingResultResponse> => {
  return apiService.post<CargoTrackingResultResponse, { phone_number: string }>(
    `/orders/${orderNumber}/track`,
    { phone_number },
  );
};
